import classes from './segmented-control.module.css'

const SegmentedControl = {
  classNames: {
    root: classes.root,
  },
}

export default SegmentedControl
